<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <sub-group-create-or-update v-model="subGroup" :errors="errors"></sub-group-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="sub-group"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import SubGroupCreateOrUpdate from './components/SubGroupCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        SubGroupCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            subGroup:{
                Id:0,
                Name:null,
                ShipableProductMainGroupId:0
            },
            fields:[
                { name:"Yük Ana Grubu",key:"ShipableProductMainGroupName", thClass:"w-50",sortable:true,sortKey:'ShipableProductMainGroup.Name'},
                { name:"Yük Alt Grubu",key:"Name", thClass:"w-50",sortable:true,}
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.subGroup.Id = 0
            this.subGroup.Name = null
            this.subGroup.ShipableProductMainGroupId = 0
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.subGroup.Id = item.Id
            this.subGroup.Name = item.Name
            this.subGroup.ShipableProductMainGroupId = item.ShipableProductMainGroupId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.SubGroup.CreateOrUpdate(this.editing,this.subGroup)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.SubGroup.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} alt grubu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.SubGroup.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>